import React, { createContext, useContext, useEffect, useState } from 'react';
import { getLocalStorage } from 'src/functions/localStorageHandler';

interface NameGeneratorHubspotFormContextData {
  isSubmitted: boolean;
  userName: string;
  userEmail: string;
  setIsSubmitted(value: boolean): void;
  setUserName(value: string): void;
  setUserEmail(value: string): void;
}

const NameGeneratorHubspotFormContext = createContext<NameGeneratorHubspotFormContextData>(
  {} as NameGeneratorHubspotFormContextData
);

const NameGeneratorHubspotFormProvider: React.FC<any> = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  // For multiple submit, name and email are to pre-populate the form if they exist
  const [userName, setUserName] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    // Submitted is not recorded, as this is a multiple-submit form
    const userName = getLocalStorage('nameGenerator:userName');
    const userEmail = getLocalStorage('nameGenerator:userEmail');

    setUserName(userName || '');
    setUserEmail(userEmail || '');
  }, []);

  return (
    <NameGeneratorHubspotFormContext.Provider
      value={{
        isSubmitted,
        setIsSubmitted,
        userName,
        setUserName,
        userEmail,
        setUserEmail,
      }}
    >
      {children}
    </NameGeneratorHubspotFormContext.Provider>
  );
};

const useNameGeneratorHubspotForm = (): NameGeneratorHubspotFormContextData => {
  const context = useContext(NameGeneratorHubspotFormContext);

  if (!context) {
    throw new Error('useNameGeneratorHubspotForm must be used within a NameGeneratorHubspotFormProvider');
  }

  return context;
};

export { useNameGeneratorHubspotForm, NameGeneratorHubspotFormProvider };
